import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-remittance-reports',
  templateUrl: './remittance-reports.component.html',
  styleUrls: ['./remittance-reports.component.scss']
})
export class RemittanceReportsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
